import { useAuthStore } from '@/store/authStore'
import { PLANS } from '@/utils/plans'
import { Check, Shield } from 'lucide-react'
import toast from 'react-hot-toast'

export default function PlanSettings() {
    const { currentOrg } = useAuthStore()

    const handleSubscribe = (checkoutUrl?: string) => {
        if (!checkoutUrl) return
        window.open(checkoutUrl, '_blank')
        toast.success('Redirecionando para o pagamento...')
    }

    return (
        <div className="space-y-12 animate-in fade-in duration-500">
            <div className="text-center space-y-4">
                <h2 className="text-3xl font-black text-[#001c28] uppercase tracking-tighter">
                    Gerencie sua <span className="text-[#d4a94d]">Assinatura</span>
                </h2>
                <p className="text-[#001c28]/60 font-medium max-w-2xl mx-auto">
                    Compare os planos e escolha a melhor opção para sua organização.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                {Object.values(PLANS).map((plan) => {
                    const isCurrent = currentOrg?.plan === plan.id
                    const isRecommended = plan.recommended

                    return (
                        <div
                            key={plan.id}
                            className={`relative bg-white rounded-[2.5rem] p-8 border-2 flex flex-col transition-all duration-300 hover:-translate-y-2
                                ${isCurrent ? 'border-[#d4a94d] ring-4 ring-[#d4a94d]/10' :
                                    isRecommended ? 'border-[#001c28] shadow-2xl shadow-[#001c28]/20 scale-105 z-10' : 'border-[#001c28]/10 hover:border-[#001c28]/20 hover:shadow-xl'}
                            `}
                        >
                            {isCurrent && (
                                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#d4a94d] text-white px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
                                    Plano Atual
                                </div>
                            )}
                            {isRecommended && !isCurrent && (
                                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#001c28] text-white px-4 py-1 rounded-full text-[10px] font-black uppercase tracking-widest">
                                    Recomendado
                                </div>
                            )}

                            <div className="mb-6 space-y-2 text-center">
                                <h3 className="text-xl font-black text-[#001c28] uppercase tracking-tight">{plan.name}</h3>
                                <div className="flex items-baseline justify-center">
                                    <span className="text-sm font-bold text-[#001c28]/40">R$</span>
                                    <span className="text-4xl font-black text-[#001c28] tracking-tighter">{plan.price.toFixed(2).replace('.', ',')}</span>
                                    <span className="text-sm font-bold text-[#001c28]/40">/mês</span>
                                </div>
                            </div>

                            <ul className="space-y-4 mb-8 flex-grow">
                                {plan.features.map((feature, i) => (
                                    <li key={i} className="flex items-start text-sm text-[#001c28]/70 font-medium leading-tight">
                                        <Check className="w-4 h-4 text-[#d4a94d] mr-2 flex-shrink-0 mt-0.5" />
                                        {feature}
                                    </li>
                                ))}
                            </ul>

                            <button
                                onClick={() => handleSubscribe(plan.checkoutUrl)}
                                disabled={isCurrent || plan.price === 0}
                                className={`w-full py-4 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all
                                    ${isCurrent
                                        ? 'bg-[#d4a94d]/10 text-[#d4a94d] cursor-default'
                                        : isRecommended
                                            ? 'bg-[#001c28] text-[#d4a94d] hover:bg-[#d4a94d] hover:text-[#001c28] shadow-lg shadow-[#001c28]/30'
                                            : 'bg-[#001c28] text-white hover:bg-[#001c28]/90'}
                                    disabled:opacity-50 disabled:cursor-not-allowed
                                `}
                            >
                                {isCurrent ? 'Seu Plano' : plan.price === 0 ? 'Plano Gratuito' : 'Assinar Agora'}
                            </button>
                        </div>
                    )
                })}
            </div>

            <div className="bg-[#001c28]/[0.02] rounded-[3rem] p-12 text-center space-y-6">
                <Shield className="w-12 h-12 text-[#001c28]/20 mx-auto" />
                <div className="space-y-2">
                    <h3 className="text-lg font-black text-[#001c28] uppercase tracking-tight">Pagamento Seguro</h3>
                    <p className="text-sm text-[#001c28]/60 font-medium max-w-lg mx-auto">
                        Seus pagamentos são processados pelo Mercado Pago com criptografia de ponta a ponta.
                        Você pode cancelar sua assinatura a qualquer momento.
                    </p>
                </div>
            </div>
        </div>
    )
}
